import React from "react";

export default function BannerWithLogo({
  title,
  description,
  logoImage,
  buttonText,
  buttonLink,
}) {
  return (
    <section className="relative w-full h-[500px] sm:h-[500px] lg:h-[600px] bg-transparent">
      <div className="absolute inset-0 flex items-center justify-center text-center p-6">
        <div className="max-w-3xl mx-auto bg-black/55 sm:px-6 px-4 sm:py-10 py-6 rounded-lg">
          {logoImage && (
            <div className="flex justify-center mb-4">
              <img
                src={logoImage}
                alt="Logo"
                className="h-16 sm:h-20 lg:h-24 object-contain"
              />
            </div>
          )}

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#c03ca0] mb-4">
            {title}
          </h1>

          <p className="text-base sm:text-lg leading-relaxed mb-6 text-white">
            {description}
          </p>

          {buttonText && buttonLink && (
            <a
              href={buttonLink}
              className="inline-block bg-[#c03ca0] text-white font-medium px-6 py-3 rounded-md hover:bg-[#a02b88] transition"
            >
              {buttonText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
